/* External Imports */
import { Box, Heading, Text, useBreakpointValue } from '@chakra-ui/react';
/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import config from '@config';
/* Styles */
import styles from '@lb/Sections/aboutDevi/styles.module.css';

const AboutDeviSlide3 = ({ section }) => {
  return (
    <Box
      background={`#000 url(${config.imgPath}/d/46272/1684474039-ib_secion3bg.jpg) no-repeat center top`}
      bgSize={{
        base: '43rem',
        sm: '47rem',
        md: 'contain',
        xl: 'cover',
      }}
      bgColor="#000"
      className={styles.section3Bg}
      pb={{ base: '2rem', xl: 0 }}
      overflow="hidden"
      position="relative"
      _before={{
        pos: 'absolute',
        bottom: 0,
        height: useBreakpointValue({
          base: '55rem',
          md: '40rem',
          lg: '60rem',
          xl: '12rem',
        }),
        width: '100%',
        bgImg: useBreakpointValue({
          base: 'linear-gradient(180deg, rgba(1, 1, 1, 0) 0%, #010101 100%)',
          md: 'linear-gradient(180deg, rgba(1, 1, 1, 0) 0%, #010101 100%)',
        }),
        content: '" "',
      }}
    >
      <Box
        maxW="1200px"
        mx="auto"
        minH="100vh"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        pos="relative"
        flexDir={{ base: 'column-reverse', xl: 'row' }}
        px={4}
      >
        <Box
          width={{ base: '100%', sm: '28rem', md: '440px' }}
          px={{ base: 4, xl: 0 }}
        >
          <Text color="#fff" fontSize={{ base: '1.125rem', lg: '24px' }} mb={4}>
            {section?.sectionContent?.[0]?.text}
          </Text>
          <Heading
            color="#D47A33"
            fontSize={{ base: '2.875rem', lg: '66px' }}
            lineHeight={{ base: '3rem', lg: '4.5rem' }}
            fontFamily="'FedraSerifDisplay'"
          >
            {section?.sectionContent?.[1]?.text}
          </Heading>
        </Box>
        <Box
          display="flex"
          justifyContent="center"
          width="100%"
          pt={{
            base: '7rem',
            md: '11rem',
            xl: 0,
          }}
          ml={{ base: '0', lg: '-2rem' }}
        >
          <LazyLoadImageComponent
            src={useBreakpointValue({
              base: `${config.imgPath}/d/46272/1684475469-lb_mob_maa.png`,
              xl: `${config.imgPath}/d/46272/1684475400-lb_maa.png`,
            })}
            alt="maa"
            width={useBreakpointValue({
              base: '6rem',
              lg: '9.5rem',
              xl: '12rem',
            })}
            position={{ base: 'static', xl: 'absolute' }}
            bottom="0px"
            right={{ base: '10px', lg: '0px' }}
            zIndex="4"
            transform={{ base: '', xl: 'translate(-50%, 0px)' }}
            left="46%"
          />
        </Box>
      </Box>
    </Box>
  );
};
export default AboutDeviSlide3;
